<script>
export default {
  inject: ["gsap"],
  name: "CostServicesManagement",
  mounted(){
    var element = $(".green-path")

    this.gsap.to(".green-path", {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });
  }
}
</script>

<template>
  <div class="cost-services management reinvest left">
    <h1 class="left flex flex-xy-center">Стоимость услуг</h1>
    <div class="cost-cards-container left flex flex-xy-center">
      <div class="cost-card management left flex flex-xy-center flex-column">
        <span class="price-desc-management"><span class="blue-text-management">от 5%</span> от арендной платы за объект в месяц</span>
        <span class="price-invest-management">Точная стоимость зависит <br>от выбранных тарифов и услуг</span>
      </div>

      <svg class="green-path  mobile-nv" width="1920" height="435" viewBox="0 0 1920 435" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-50 2C-39.3333 104.333 42.7 320.9 285.5 368.5C589 428 696 274.5 937 284C1178 293.5 1387.5 409.5 1572.5 422C1720.5 432 1895.17 292.5 1964 221.5" stroke="#B2DBBF" stroke-width="24"/>
      </svg>
    </div>
  </div>
</template>

<style scoped>

</style>